<template>
  <transition-group name="flip-expand" tag="ul" class="demographics-list">
    <DemographicsItem
      v-for="(demoItem, index) in demoList"
      :key="demoItem.id"
      :data="demoItem"
      :deletable="demoList.length > 2 && index !== demoList.length - 1"
      :ageData="ageList"
      :genderData="genderList"
      :grayed="index === demoList.length - 1 && demoItem.ageId === 0 && demoItem.genderId === 0"
      @update="updateDemoItem(demoItem.id, $event)"
      @remove="removeDemoItem(demoItem.id)"
    />
  </transition-group>
</template>

<script>
import DemographicsItem from '@/components/participation/DemographicsItem.vue';

export default {
  name: 'DemographicsList',

  props: {
    data: {
      type: Array,
      default: () => {
        return [];
      },
    },
  },

  data() {
    return {
      ageList: [],
      genderList: [],
    };
  },

  async created() {
    const ageData = await this.$api.get('/metas/type/age');
    this.ageList = ageData.records.map((age) => ({ value: age.id, name: age.meta_value }));
    this.ageList.unshift({ value: 0, name: '-- --' });

    const genderData = await this.$api.get('/metas/type/gender');
    this.genderList = genderData.records.map((gender) => ({ value: gender.id, name: gender.meta_value }));
    this.genderList.unshift({ value: 0, name: '-- --' });
  },

  methods: {
    updateDemoItem(id, newItem) {
      this.demoList = this.demoList.map((demoItem) => (demoItem.id === id ? newItem : demoItem));
    },
    removeDemoItem(id) {
      this.demoList = this.demoList.filter((demoItem) => demoItem.id !== id);
    },
  },

  computed: {
    demoList: {
      get() {
        return this.data;
      },
      set(newVal) {
        this.$emit('update', newVal);
      },
    },
  },

  components: {
    DemographicsItem,
  },
};
</script>

<style scoped>
.demographics-list {
  width: 100%;
}

.flip-expand-enter-active,
.flip-expand-leave-active {
  transition: 0.3s all;
  transform-origin: top center;
}
.flip-expand-enter,
.flip-expand-leave-to {
  opacity: 0;
  transform: scaleY(0);
}
.flip-expand-enter-to,
.flip-expand-leave {
  opacity: 1;
  transform: scaleY(1);
}
</style>
